import { jsxs as r, jsx as t, Fragment as h } from "react/jsx-runtime";
import { Iconify as u } from "../Iconify/index.js";
import { useState as x } from "react";
function g({
  width: e = 24,
  height: i = 24
}) {
  return /* @__PURE__ */ r("svg", { viewBox: "0 0 24 24", height: i, width: e, children: [
    /* @__PURE__ */ t(
      "path",
      {
        d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z",
        fill: "#4285F4"
      }
    ),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z",
        fill: "#34A853"
      }
    ),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z",
        fill: "#FBBC05"
      }
    ),
    /* @__PURE__ */ t(
      "path",
      {
        d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z",
        fill: "#EA4335"
      }
    ),
    /* @__PURE__ */ t("path", { d: "M1 1h22v22H1z", fill: "none" })
  ] });
}
function y({
  width: e = 25,
  height: i = 25
}) {
  return /* @__PURE__ */ r("svg", { viewBox: "0 0 799.89 761", width: e, height: i, children: [
    /* @__PURE__ */ t(
      "path",
      {
        d: "M799.89 290.83H494.44L400.09 0l-94.64 290.83L0 290.54l247.37 179.92L152.72 761l247.37-179.63L647.16 761l-94.35-290.54z",
        fill: "#00b67a"
      }
    ),
    /* @__PURE__ */ t("path", { d: "M574.04 536.24l-21.23-65.78-152.72 110.91z", fill: "#005128" })
  ] });
}
function C({
  source: e,
  sourceLink: i,
  direction: s
}) {
  const n = m(e), l = b(e);
  return /* @__PURE__ */ t(
    w,
    {
      direction: s,
      title: /* @__PURE__ */ t("div", { style: a.wrapper, children: /* @__PURE__ */ t("p", { style: a.text, children: l }) }),
      children: /* @__PURE__ */ t(
        "span",
        {
          onClick: (c) => {
            i && (c.stopPropagation(), window.open(i, "_blank"));
          },
          children: n
        }
      )
    }
  );
}
function b(e) {
  switch (e) {
    case "trustpilot":
      return "Linked from Trustpilot";
    case "google":
      return "Linked from Google";
    default:
      return "Verified by Simply";
  }
}
function m(e) {
  switch (e) {
    case "trustpilot":
      return /* @__PURE__ */ t(y, { width: 18, height: 18 });
    case "google":
      return /* @__PURE__ */ t(g, { width: 16, height: 18 });
    default:
      return /* @__PURE__ */ r(h, { children: [
        /* @__PURE__ */ t(
          u,
          {
            icon: "ic:round-verified",
            width: 18,
            height: 18,
            style: a.icon
          }
        ),
        /* @__PURE__ */ t("div", { style: a.iconBg })
      ] });
  }
}
const a = {
  wrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  iconWrapper: {
    display: "flex",
    position: "relative"
  },
  icon: {
    marginTop: 1,
    color: "#0DA800",
    position: "relative",
    zIndex: 1
  },
  iconBg: {
    width: 10,
    height: 10,
    backgroundColor: "#fff",
    position: "absolute",
    top: 4,
    left: 4,
    borderRadius: "50%",
    zIndex: 0
  },
  leftSpace: { marginLeft: 4 },
  text: {
    fontFamily: "Roboto, sans-serif",
    margin: 0,
    lineHeight: 1.5,
    fontSize: 10
  }
}, w = ({
  children: e,
  title: i,
  direction: s
}) => {
  const [n, l] = x(!1), c = {
    visibility: n ? "visible" : "hidden",
    opacity: n ? 1 : 0
  }, { textStyle: d, arrowStyle: p } = v(s), f = { ...d, ...c };
  return /* @__PURE__ */ r(
    "div",
    {
      style: o.container,
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      children: [
        e,
        /* @__PURE__ */ r("div", { style: f, children: [
          i,
          /* @__PURE__ */ t("div", { style: p })
        ] })
      ]
    }
  );
};
function v(e) {
  return e === "right" ? {
    textStyle: o.textLeft,
    arrowStyle: o.arrowLeft
  } : {
    textStyle: o.text,
    arrowStyle: o.arrow
  };
}
const o = {
  // Styles for the tooltip container
  container: {
    position: "relative",
    display: "inline-block",
    cursor: "pointer"
  },
  // Styles for the tooltip text
  text: {
    width: "max-content",
    backgroundColor: "#222",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    textAlign: "center",
    borderRadius: "6px",
    padding: "4px 8px 5px",
    position: "absolute",
    zIndex: 1,
    bottom: "125%",
    // Position the tooltip above the text
    left: "50%",
    transform: "translateX(-50%)",
    transition: "opacity 0.3s"
  },
  // Styles for the tooltip arrow
  arrow: {
    position: "absolute",
    top: "95%",
    // At the bottom of the tooltip
    left: "50%",
    marginLeft: "-5px",
    width: "0",
    height: "0",
    borderWidth: "5px",
    borderStyle: "solid",
    borderColor: "#222 transparent transparent transparent"
  },
  // Styles for the tooltip text
  textLeft: {
    width: "max-content",
    backgroundColor: "#222",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    textAlign: "center",
    borderRadius: "6px",
    padding: "4px 8px 5px",
    position: "absolute",
    zIndex: 1,
    top: "-10%",
    // Position the tooltip above the text
    left: "0%",
    transform: "translateX(30%)",
    transition: "opacity 0.3s"
  },
  // Styles for the tooltip arrow
  arrowLeft: {
    position: "absolute",
    top: "30%",
    // At the bottom of the tooltip
    left: "-4%",
    marginLeft: "-5px",
    width: "0",
    height: "0",
    borderWidth: "5px",
    borderStyle: "solid",
    borderColor: "transparent #222 transparent transparent"
  }
};
export {
  C as Verified,
  m as getSourceIcon
};
